import React from 'react';
import { Container, Paper, Text, Divider } from '@mantine/core';
import FileAnswerView from '../FileAnswerView';

export default function ResponseCard({ title, answer }) {

const renderAnswer = (value) => {
  if (value == null) {
    return <Text color="dimmed">No response</Text>;
  }

  // Signature pad (base64 image)
  if (typeof value === 'string' && value.startsWith('data:image')) {
    return (
      <img
        src={value}
        alt="signature"
        loading="lazy"
        style={{
          maxWidth: 220,
          border: '1px solid #ccc',
          borderRadius: 4
        }}
      />
    );
  }

  // Simple string / number
  if (typeof value === 'string' || typeof value === 'number') {
    return value
      .toString()
      .split(/[;,]/)
      .map((item, idx) => (
        <Text key={idx}>{item.trim()}</Text>
      ));
  }

  // Array (checkbox, image picker, multiple files)
  if (Array.isArray(value)) {
    return value.map((item, idx) => (
      <div key={idx} style={{ marginBottom: 6 }}>
        {renderAnswer(item)}
      </div>
    ));
  }

  // File upload object
  if (typeof value === 'object') {
    return <FileAnswerView value={value} />;
  }

  return <Text>-</Text>;
};


  return (
    <div>
      <Container>
        <Paper p={5} m={5} radius="sm" shadow="lg" style={{ border: '1.5px solid #bababa' }}>
          <Container fluid p={5} m={5}>
            <h5 style={{textTransform: 'capitalize'}}>{title}</h5>
          </Container>
          <Divider my="xs" size="sm" />
          <Container>
            {/* {answer} */}
             {renderAnswer(answer)}
          </Container>
        </Paper>
      </Container>
    </div>
  );
}
